// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PremiosMayores_container__1QL\\+X {
  animation: PremiosMayores_init__dferA 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
}

/*--Header--*/
.PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d .PremiosMayores_titleContainer__arlpa {
  display: flex;
  align-items: center;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d .PremiosMayores_titleContainer__arlpa h4 {
  text-align: center;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d .PremiosMayores_uploadBtn__k4CMJ {
  margin-top: 5px;
  width: 100%;
  margin-bottom: 10px;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_noResults__qTuMb {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 2rem;
  font-weight: 300;
  height: 300px;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d .PremiosMayores_arrow__d9eVW {
  transition: 0.3s;
  border-radius: 100%;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d .PremiosMayores_arrow__d9eVW:hover {
  transition: 0.3s;
  scale: 1.1;
  filter: brightness(1.2);
  background-color: rgba(128, 128, 128, 0.15);
  cursor: pointer;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d .PremiosMayores_filters__xP5F5 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d .PremiosMayores_filters__xP5F5 .PremiosMayores_filterButton__4r\\+3S {
  height: 3rem;
  width: 10rem;
  margin-top: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d .PremiosMayores_filters__xP5F5 .PremiosMayores_filterButton__4r\\+3S p {
  font-size: 0.9rem;
  margin-left: 5px;
  font-weight: 400;
}

/*---Información---*/
.PremiosMayores_container__1QL\\+X .PremiosMayores_data__PH1Q\\+ .PremiosMayores_tableContainer__7uHWi {
  animation: PremiosMayores_init2__FtFB0 0.5s;
  border-radius: 5px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_data__PH1Q\\+ .PremiosMayores_tableContainer__7uHWi .PremiosMayores_iconbtn__\\+T-Tp {
  transition: 0.3s;
  font-size: 2rem;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_data__PH1Q\\+ .PremiosMayores_tableContainer__7uHWi .PremiosMayores_iconbtn__\\+T-Tp:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_data__PH1Q\\+ .PremiosMayores_pagination__ZRcD4 {
  margin-top: 50px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_loader__26Cnh {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.PremiosMayores_container__1QL\\+X .PremiosMayores_loader__26Cnh {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

@media screen and (max-width: 500px) {
  .PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d {
    margin-top: 40px;
  }

  .PremiosMayores_container__1QL\\+X .PremiosMayores_header__HtD7d .PremiosMayores_titleContainer__arlpa h4 {
    font-size: 1.5rem;
  }

  .PremiosMayores_container__1QL\\+X .PremiosMayores_icon__3ywTW {
    display: none;
  }

  .PremiosMayores_container__1QL\\+X h4 {
    margin: 0;
  }
}

@keyframes PremiosMayores_init__dferA {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes PremiosMayores_init2__FtFB0 {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/PremiosMayores/PremiosMayores.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,2CAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 16px;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: center;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .uploadBtn {\n  margin-top: 5px;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 2rem;\n  font-weight: 300;\n  height: 300px;\n}\n\n.container .header .arrow {\n  transition: 0.3s;\n  border-radius: 100%;\n}\n\n.container .header .arrow:hover {\n  transition: 0.3s;\n  scale: 1.1;\n  filter: brightness(1.2);\n  background-color: rgba(128, 128, 128, 0.15);\n  cursor: pointer;\n}\n\n.container .header .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .header .filters .filterButton {\n  height: 3rem;\n  width: 10rem;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.container .header .filters .filterButton p {\n  font-size: 0.9rem;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: init2 0.5s;\n  border-radius: 5px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 2rem;\n}\n\n.container .data .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n.container .data .pagination {\n  margin-top: 50px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n@media screen and (max-width: 500px) {\n  .container .header {\n    margin-top: 40px;\n  }\n\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n\n  .container .icon {\n    display: none;\n  }\n\n  .container h4 {\n    margin: 0;\n  }\n}\n\n@keyframes init {\n  0% {\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    transform: translateX(-10px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PremiosMayores_container__1QL+X`,
	"init": `PremiosMayores_init__dferA`,
	"header": `PremiosMayores_header__HtD7d`,
	"titleContainer": `PremiosMayores_titleContainer__arlpa`,
	"uploadBtn": `PremiosMayores_uploadBtn__k4CMJ`,
	"noResults": `PremiosMayores_noResults__qTuMb`,
	"arrow": `PremiosMayores_arrow__d9eVW`,
	"filters": `PremiosMayores_filters__xP5F5`,
	"filterButton": `PremiosMayores_filterButton__4r+3S`,
	"data": `PremiosMayores_data__PH1Q+`,
	"tableContainer": `PremiosMayores_tableContainer__7uHWi`,
	"init2": `PremiosMayores_init2__FtFB0`,
	"iconbtn": `PremiosMayores_iconbtn__+T-Tp`,
	"pagination": `PremiosMayores_pagination__ZRcD4`,
	"loader": `PremiosMayores_loader__26Cnh`,
	"icon": `PremiosMayores_icon__3ywTW`
};
export default ___CSS_LOADER_EXPORT___;
